import imgStandard from '../../../../assets/cls-se/products/size-guide/standard.png';
import imgUniversal from '../../../../assets/cls-se/products/size-guide/universal.png';
import imgClassic from '../../../../assets/cls-se/products/size-guide/classic.png';
import imgZipHoodie from '../../../../assets/cls-se/products/size-guide/zip-hoodie.png';
import imgCosy from '../../../../assets/cls-se/products/size-guide/cosy.png';
import imgCrewneck from '../../../../assets/cls-se/products/size-guide/crewneck.png';
import imgUnisexTee from '../../../../assets/cls-se/products/size-guide/unisex-tee.png';
import imgWomensTee from '../../../../assets/cls-se/products/size-guide/womens-tee.png';

export const SIZE_GUIDE_TITLE = 'Storleksguide';

export const SIZE_GUIDE_ITEMS = [
  {
    name: 'Standard',
    image: imgStandard,
    sizes: [
      { label: 'Storlek A', values: 'S: 49cm • M: 54cm • L: 59cm • XL: 64cm • XXL: 69cm' },
      { label: 'Storlek B', values: 'S: 69cm • M: 71cm • L: 74cm • XL: 76cm • XXL: 79cm' },
    ],
  },
  {
    name: 'Universal',
    image: imgUniversal,
    sizes: [
      { label: 'Storlek A', values: 'XS: 47cm • S: 50cm • M: 53cm • L: 56cm • XL: 59cm • XXL: 62cm' },
      { label: 'Storlek B', values: 'XS: 68cm • S: 71cm • M: 74cm • L: 77cm • XL: 80cm • XXL: 83cm' },
    ],
  },
  {
    name: 'Classic',
    image: imgClassic,
    sizes: [
      { label: 'Storlek A', values: 'S: 57cm • M: 61cm • L: 65cm • XL: 69cm • XXL: 72cm' },
      { label: 'Storlek B', values: 'S: 66cm • M: 68cm • L: 71cm • XL: 74cm • XXL: 76cm' },
    ],
  },
  {
    name: 'Zip Hoodie',
    image: imgZipHoodie,
    sizes: [
      { label: 'Storlek A', values: 'S: 50cm • M: 53cm • L: 56cm • XL: 59cm • XXL: 62cm' },
      { label: 'Storlek B', values: 'S: 63.5cm • M: 66.5cm • L: 69.5cm • XL: 72.5cm • XXL: 75.5cm' },
    ],
  },
  {
    name: 'Cosy',
    image: imgCosy,
    sizes: [
      { label: 'Storlek A', values: 'XS: 43cm • S: 46.5cm • M: 49cm • L: 51.5cm • XL: 54cm' },
      { label: 'Storlek B', values: 'XS: 92cm • S: 94.5cm • M: 95cm • L: 95.5cm • XL: 96cm' },
    ],
  },
  {
    name: 'Crewneck',
    image: imgCrewneck,
    sizes: [
      { label: 'Storlek A', values: 'S: 50cm • M: 53cm • L: 56cm • XL: 59cm • XXL: 62cm' },
      { label: 'Storlek B', values: 'S: 69.5cm • M: 71cm • L: 72.5cm • XL: 74cm • XXL: 75.5cm' },
    ],
  },
  {
    name: 'Unisex Tee',
    image: imgUnisexTee,
    sizes: [
      { label: 'Storlek A', values: 'S: 50cm • M: 53cm • L: 56cm • XL: 60cm • XXL: 64cm' },
      { label: 'Storlek B', values: 'S: 70cm • M: 72cm • L: 73cm • XL: 76cm • XXL: 78cm' },
    ],
  },
  {
    name: 'Womens Tee',
    image: imgWomensTee,
    sizes: [
      { label: 'Storlek A', values: 'S: 44.5cm • M: 47cm • L: 49.5cm' },
      { label: 'Storlek B', values: 'S: 64cm • M: 65cm • L: 66cm' },
    ],
  },
];
